import React, { useEffect, useState , useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetLeaveTypeActions,
  SetLeaveTypeDeleteActions,
} from "../../../Redux/Slice";
import LeaveTypeCreate from "./LeaveTypeCreate";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";

const LeaveTypeStatus = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [LeaveCreate, setLeaveCraete] = useState(false);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);
  const [EditID, setEditId] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setdatas] = useState([]);

  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);

  useEffect(() => {
    const payloads = {
      search: "",
      // page_size: dtpagesize,
      page_size: 20,
      page: dtpageindex,
    };
    dispatch(SetLeaveTypeActions(payloads));
    setdatas(state.LeaveTypeList.LeaveTypeList);
  }, [dtpagesize, dtpageindex]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
const columns = [
    {
      Header: "Leave Type",
      accessor: "leave_type",
    },
    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.description != null &&
              row.row.original.description != "" ? (
                <span>{row.row.original.description}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },
    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditId(row.row.original.id);
                  setEditPopup(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                     <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>
          
            </div>
          </>
        );
      },
    },
  ];

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: 20,
          page: 1,
        };

        dispatch(SetLeaveTypeActions(payload));
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    debouncedSearch(e);
    // if (e != undefined && e !== "") {
    //   const payload = {
    //     search: e,
    //     page_size: dtpagesize,
    //     page: 1,
    //   };

    //   dispatch(SetLeaveTypeActions(payload));
    // }
    // if (e == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //   };
    //   dispatch(SetLeaveTypeActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const HandleDeletes = () => {
    if (DeleteId != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteId: DeleteId,
        currentPage: currentPage,
      };
      dispatch(SetLeaveTypeDeleteActions(payload, setDeletepopup(false)));
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Leave Type</h3>

          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setLeaveCraete(true);
                setEditId("");
              }}
              className="ButtonCSS"
            >
              Create{" "}
            </button>
          </div>
        </div>
<br/>
        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            <ReactTable
              data={state.LeaveTypeList.LeaveTypeList}
              columns={columns}
              totalItems={state.LeaveTypeList.Total_Count}
              currentPage={currentPage}
              // onPageChange={handlePageChange}

              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.LeaveTypeList.Total_Count}
              // Oncreate={(e) => setRoleCreatePopup(true)}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}

              Filter={true}
              NoFilter ={true}

            />
          </div>
        ) : null}
      </div>
      {LeaveCreate ? (
        <LeaveTypeCreate
          show={LeaveCreate}
          setShow={setLeaveCraete}
          currentPage={currentPage}
        />
      ) : null}
      {EditPopupCall && EditID != undefined ? (
        <LeaveTypeCreate
          show={EditPopupCall}
          setShow={setEditPopup}
          currentPage={dtpageindex}
          EditID={EditID}
          search={search}
        />
      ) : null}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletepopup}
          onSubmit={HandleDeletes}
        />
      ) : null}
    </>
  );
};

export default LeaveTypeStatus;
